export default __webpack_public_path__ + "assets/img/avatar-driver.651c408.png";